(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
var relatedProductSectionRequests = new WeakMap();

var fetchRelatedProductSection = function(url, signal) {
  return fetch(url, { credentials: 'same-origin', signal: signal }).then(function(response) {
    if (!response.ok) { throw new Error('Related products request failed'); }
    return response.text();
  }).then(function(html) {
    var container = document.createElement('div');
    container.innerHTML = html;
    return container;
  });
};

var readRelatedProductCandidates = function(container) {
  return Array.from(container.querySelectorAll('[data-related-product-candidate]')).map(function(candidate) {
    return {
      id: candidate.dataset.productId,
      url: candidate.dataset.productUrl,
      priceBand: candidate.dataset.priceBand || '',
      isBestSeller: candidate.dataset.bestSeller === 'true',
      isNew: candidate.dataset.new === 'true'
    };
  });
};

var fetchRelatedProductCard = function(candidate, cardSectionId, signal) {
  var url = new URL(candidate.url, window.location.origin);
  url.search = '';
  url.searchParams.set('section_id', cardSectionId);

  return fetchRelatedProductSection(url.toString(), signal).then(function(container) {
    var card = container.querySelector('[data-related-product-card]');
    return card ? card.firstElementChild : null;
  });
};

var renderRelatedProductCards = function(section, cards) {
  var grid = section.querySelector('.product-grid');
  if (!grid || cards.length === 0) { return; }

  var fragment = document.createDocumentFragment();

  cards.forEach(function(card) {
    var sliderItem = document.createElement('div');
    sliderItem.className = 'slider__item';
    sliderItem.appendChild(card);
    fragment.appendChild(sliderItem);
  });

  grid.replaceChildren(fragment);
  section.hidden = false;
  section.querySelectorAll('carousel-slider').forEach(function(carousel) {
    if (typeof carousel.refresh === 'function') { carousel.refresh(); }
  });
  observeYouMayAlsoLike(section);
};

// 详情页 You May Also Like 只发 ymal_*。通用 section_view / view_item_list / select_item 由 theme-analytics 排除。
var ymalTrack = function(eventName, params) {
  var detail = { eventName: eventName, params: params };
  if (!window.themeAnalytics) {
    (window.ymalAnalyticsQueue = window.ymalAnalyticsQueue || []).push(detail);
    return true;
  }
  return document.dispatchEvent(new CustomEvent('ymal:track', { cancelable: true, detail: detail }));
};

var ymalWidgetPosition = function(section) {
  return Array.from(document.querySelectorAll('[data-analytics-section]')).indexOf(section) + 1;
};

var ymalImpressedCards = new WeakSet();

var observeYouMayAlsoLike = function(section) {
  if (!section) return;

  var cards = Array.from(section.querySelectorAll('product-block'));
  cards.forEach(function(card, index) {
    card.dataset.ymalPosition = String(index + 1);
  });
  if (cards.length === 0) return;

  if (section._ymalViewObserver) section._ymalViewObserver.disconnect();
  if (section._ymalItemObserver) section._ymalItemObserver.disconnect();

  var mainProductId = section.dataset.currentProductId;
  var widgetPosition = ymalWidgetPosition(section);

  var sendView = function() {
    if (section.dataset.ymalViewSent === 'true') return;
    var sent = ymalTrack('ymal_view', {
      main_product_id: mainProductId,
      recommendation_product_ids: cards.map(function(card) {
        return card.dataset.productId || card.dataset.analyticsItemId || '';
      }).filter(Boolean).join(','),
      recommendation_count: cards.length,
      widget_position: widgetPosition
    });
    if (!sent) return;
    section.dataset.ymalViewSent = 'true';
    if (section._ymalViewObserver) section._ymalViewObserver.disconnect();
  };

  var sendImpression = function(card) {
    if (ymalImpressedCards.has(card)) return;
    var productId = card.dataset.productId || card.dataset.analyticsItemId;
    if (!productId) return;
    var sent = ymalTrack('ymal_product_impression', {
      main_product_id: mainProductId,
      recommendation_product_id: productId,
      recommendation_position: Number(card.dataset.ymalPosition),
      widget_position: widgetPosition
    });
    if (!sent) return;
    ymalImpressedCards.add(card);
    if (section._ymalItemObserver) section._ymalItemObserver.unobserve(card);
  };

  if (!window.IntersectionObserver) {
    sendView();
    cards.forEach(sendImpression);
  } else {
    section._ymalViewObserver = new IntersectionObserver(function(entries) {
      if (entries.some(function(entry) {
        return entry.isIntersecting && entry.intersectionRatio >= 0.5 && !document.hidden;
      })) sendView();
    }, { threshold: [0.5] });
    section._ymalViewObserver.observe(section);

    section._ymalItemObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5 || document.hidden) return;
        sendImpression(entry.target);
      });
    }, { threshold: [0.5] });
    cards.forEach(function(card) {
      if (ymalImpressedCards.has(card)) return;
      section._ymalItemObserver.observe(card);
    });
  }

  if (section.dataset.ymalClickBound === 'true') return;
  section.dataset.ymalClickBound = 'true';
  section.addEventListener('click', function(event) {
    var target = event.target && event.target.nodeType === 1 ? event.target : event.target && event.target.parentElement;
    var control = target && target.closest && target.closest('a, button, [role="button"]');
    if (!control || !control.matches('a.product-link, a.quickbuy-toggle')) return;
    var card = control.closest('product-block');
    if (!card || !section.contains(card)) return;
    var productId = card.dataset.productId || card.dataset.analyticsItemId;
    if (!productId) return;

    var path = '';
    try {
      path = new URL(control.href, window.location.origin).pathname;
    } catch (error) {
      path = '';
    }
    var params = {
      main_product_id: section.dataset.currentProductId,
      recommendation_product_id: productId,
      recommendation_position: Number(card.dataset.ymalPosition) || undefined,
      recommendation_source: 'you_may_also_like'
    };
    var sent = ymalTrack('ymal_product_click', params);
    if (!sent || !path) return;
    try {
      sessionStorage.setItem('ymal_attribution', JSON.stringify(Object.assign({}, params, {
        recommendation_path: path,
        timestamp: Date.now()
      })));
    } catch (error) {
      // 归因写不进会话时仍保留本次点击，但不延续到后续 PDP。
    }
  }, true);
};

document.addEventListener('visitorConsentCollected', function() {
  document.querySelectorAll('.related-products[data-ymal]').forEach(function(section) {
    if (section.hidden) return;
    observeYouMayAlsoLike(section);
  });
});

var loadRelatedProductsIntoSection = async function(section) {
  if (!section || !section.dataset.searchUrl) { return; }

  var previousController = relatedProductSectionRequests.get(section);
  if (previousController) { previousController.abort(); }

  var controller = new AbortController();
  relatedProductSectionRequests.set(section, controller);

  var maxProducts = Number(section.dataset.maxProducts) || 10;
  var currentProductId = section.dataset.currentProductId;
  var currentPriceBand = section.dataset.currentPriceBand;
  var selectedCandidates = [];
  var selectedIds = new Set([currentProductId]);

  var addCandidates = function(candidates, predicate) {
    candidates.forEach(function(candidate) {
      if (selectedCandidates.length >= maxProducts || selectedIds.has(candidate.id)) { return; }
      if (predicate && !predicate(candidate)) { return; }
      selectedIds.add(candidate.id);
      selectedCandidates.push(candidate);
    });
  };

  try {
    try {
      var searchContainer = await fetchRelatedProductSection(section.dataset.searchUrl, controller.signal);
      var searchCandidates = readRelatedProductCandidates(searchContainer);

      addCandidates(searchCandidates, function(candidate) {
        return candidate.isBestSeller && candidate.priceBand === currentPriceBand;
      });
      addCandidates(searchCandidates, function(candidate) {
        return candidate.isNew;
      });
      addCandidates(searchCandidates);
    } catch (searchError) {
      if (searchError.name === 'AbortError') { throw searchError; }
      console.warn('Unable to search related products.', searchError);
    }

    if (selectedCandidates.length < maxProducts && section.dataset.recommendationsUrl) {
      try {
        var fallbackContainer = await fetchRelatedProductSection(section.dataset.recommendationsUrl, controller.signal);
        addCandidates(readRelatedProductCandidates(fallbackContainer));
      } catch (fallbackError) {
        if (fallbackError.name === 'AbortError') { throw fallbackError; }
        console.warn('Unable to load fallback product recommendations.', fallbackError);
      }
    }

    if (selectedCandidates.length < maxProducts && section.dataset.genderSearchUrl) {
      try {
        var genderSearchContainer = await fetchRelatedProductSection(section.dataset.genderSearchUrl, controller.signal);
        addCandidates(readRelatedProductCandidates(genderSearchContainer));
      } catch (genderSearchError) {
        if (genderSearchError.name === 'AbortError') { throw genderSearchError; }
        console.warn('Unable to load gender-and-style related products.', genderSearchError);
      }
    }

    if (selectedCandidates.length === 0) { return; }

    var cards = await Promise.all(selectedCandidates.map(function(candidate) {
      return fetchRelatedProductCard(candidate, section.dataset.cardSectionId, controller.signal);
    }));
    cards = cards.filter(Boolean);

    if (cards.length === 0) { return; }
    renderRelatedProductCards(section, cards);
  } catch (error) {
    if (error.name !== 'AbortError') {
      console.warn('Unable to render related products.', error);
    }
  } finally {
    if (relatedProductSectionRequests.get(section) === controller) {
      relatedProductSectionRequests.delete(section);
    }
  }
};

document.addEventListener('shopify:section:load', function(event) {
  loadRelatedProductsIntoSection(event.target.querySelector('.related-products[data-search-url]'));
});

document.addEventListener('shopify:section:unload', function(event) {
  var section = event.target.querySelector('.related-products[data-search-url]');
  var controller = section && relatedProductSectionRequests.get(section);
  if (controller) { controller.abort(); }
  if (section && section._ymalViewObserver) section._ymalViewObserver.disconnect();
  if (section && section._ymalItemObserver) section._ymalItemObserver.disconnect();
});

document.querySelectorAll('.related-products[data-search-url]').forEach(function(section) {
  loadRelatedProductsIntoSection(section);
});

  } catch(e) { console.error(e); }
})();
})();
